import { Container, useMediaQuery, useTheme } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import leftPic from "../../../images/Ghorami home/cm-16.png";
import Slider from "react-slick";
import RightContent from "./RightContent";
import { useEffect } from "react";
import { useState } from "react";
import { testimonialApi } from "../../API/Api";

const Testimonial = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    fetch(testimonialApi)
      .then((res) => res.json())
      .then((result) => {
        setTestimonialData(result);
      })
      .catch((error) => console.log("testimonial error => ", error));
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    adaptiveHeight: true,
    fade: true,
  };
  return (
    <Box
      sx={{
        bgcolor: "#040610",
        mt: 0,
        py: { xs: 4, md: 8 },
        px: { xs: 2, md: 6 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Optional subtle vertical gradient background overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "70vh",
          bgcolor: "rgba(4, 6, 16, 0.85)",
          backgroundImage:
            "radial-gradient(circle at 20% 30%, #22AB7D55, transparent 70%), radial-gradient(circle at 80% 70%, #176B4A55, transparent 70%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />

      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="center"
        alignItems="center"
        spacing={{ xs: 4, md: 0 }}
        sx={{ position: "relative", zIndex: 2 }}
      >
        {/* Left image - hidden on xs/sm */}
        {!isMobile && (
          <Box
            component="img"
            src={leftPic}
            alt="AI Inspired Visual"
            sx={{
              width: "60%",
              maxWidth: 500,
              borderRadius: "20px",
              filter: "drop-shadow(0 0 12px #22AB7D88)",
              userSelect: "none",
              flexShrink: 0,
            }}
          />
        )}

        {/* Testimonial Slider */}
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            maxWidth: 600,
            backdropFilter: "blur(12px)",
            backgroundColor: "rgba(255 255 255 / 0.07)",
            borderRadius: "20px",
            boxShadow:
              "0 8px 32px 0 rgba(34, 171, 125, 0.37), 0 0 15px #22AB7D66",
            p: 4,
          }}
        >
          <Slider {...settings}>
            {testimonialData.map((element) => (
              <Box
                key={element.refer}
                sx={{
                  outline: "none", // Remove focus outline on slide
                }}
              >
                <RightContent testimonialData={element} />
              </Box>
            ))}
          </Slider>
        </Box>
      </Stack>
    </Box>
  );
};

export default Testimonial;
